import { useCallback } from "react";

import { swSettings } from "app/common/services/swSettings";
import type { User } from "app/components/impersonate-popup/types";

export const useImpersonateUser = () => {
    const impersonateUser = useCallback((row: User) => {
        try {
            window.localStorage.setItem("impersonationRequested", JSON.stringify(true));
        } catch (e) {
            console.error("Failed to set localStorage item:", e);
        }

        window.location.href =
            `${swSettings.swsites.pro}/useridentity/switchidentity?` +
            `name=${encodeURIComponent(row.Email)}&` +
            `userId=${row.Id}&` +
            `redirectTo=${encodeURIComponent(location.href)}`;
    }, []);

    return { impersonateUser };
};
